import { BadgeTitle, BadgeValue, InfoBadge } from '../../styles';
import { DynamicIcon } from 'lucide-react/dynamic';
import { InfoStack, InfoHeader } from '../styles';
interface InfoDisplayProps {
  label: string;
  value: string | number;
}

// Component to display customer information in a structured format with an icon and title
function InfoDisplay({
  title,
  info,
  modeView,
  icon,
  color,
}: {
  title: string;
  info: InfoDisplayProps[];
  modeView: string;
  icon: 'router' | 'hard-drive' | 'utility-pole';
  color: string;
}) {
  return (
    <InfoStack color={color}>
      <InfoHeader color={color}>
        <DynamicIcon name={icon} color={color} size={20} />
        {title}
      </InfoHeader>
      {info.map((item) => (
        <>
          <InfoBadge modeView={modeView}>
            <BadgeTitle>{item.label}</BadgeTitle>
            <BadgeValue>{item.value}</BadgeValue>
          </InfoBadge>
        </>
      ))}
    </InfoStack>
  );
}

export default InfoDisplay;
